(() => {
  const boot = () => {
    if (document.body.dataset.mmSiteUx) return;
    document.body.dataset.mmSiteUx = 'true';
    let currentCart;
    const markBasketProducts = () => {
      if (!currentCart) return;
      const ids = new Set(currentCart.items.map(item => String(item.product_id)));
      document.querySelectorAll('[data-mm-card-product]').forEach(card => {
        const badge = card.querySelector('[data-mm-card-in-basket]');
        if (badge) badge.hidden = !ids.has(card.dataset.mmCardProduct);
      });
    };
    document.addEventListener('mm:cart:updated', event => { currentCart = event.detail.cart; markBasketProducts(); });
    document.addEventListener('mm:collection:updated', markBasketProducts);
    const basket = document.getElementById('mm-bag');
    const drawer = basket?.querySelector('[data-mm-drawer-body]');
    const subscription = document.getElementById('mm-site-subscription');
    let subscriptionTrigger;
    document.addEventListener('click', event => {
      const opener = event.target.closest('[data-mm-site-sub-open]');
      if (opener && subscription) {
        subscriptionTrigger = opener;
        subscription.dispatchEvent(new CustomEvent('mm:overlay:reset', {bubbles:true}));
        if (!subscription.open) subscription.showModal();
      }
      if (event.target.closest('[data-mm-site-sub-close]')) subscription?.close();
    });
    subscription?.addEventListener('close', () => subscriptionTrigger?.focus());
    subscription?.addEventListener('click', event => {
      if (event.target !== subscription) return;
      const rect = subscription.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) subscription.close();
    });
    const activate = (key, focus = false) => {
      const tabs = [...(drawer?.querySelectorAll('[data-mm-site-tab]') || [])];
      const selected = tabs.find(tab => tab.dataset.mmSiteTab === key) || tabs[0];
      if (!selected) return;
      basket.dataset.mmCartTab = selected.dataset.mmSiteTab;
      tabs.forEach(tab => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      drawer.querySelectorAll('[data-mm-site-panel]').forEach(panel => panel.hidden = panel.dataset.mmSitePanel !== selected.dataset.mmSiteTab);
      if (focus) selected.focus();
    };
    if (drawer) {
      new MutationObserver(() => activate(basket.dataset.mmCartTab || 'items')).observe(drawer, {childList: true});
      activate('items');
    }
    document.addEventListener('click', event => {
      const tab = event.target.closest('[data-mm-site-tab]');
      if (tab) {
        activate(tab.dataset.mmSiteTab);
        const scroll = drawer.querySelector('.mm-cart-scroll');
        if (scroll) scroll.scrollTop = 0;
      }
    });
    drawer?.addEventListener('keydown', event => {
      const current = event.target.closest('[data-mm-site-tab]');
      if (!current || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      const tabs = [...drawer.querySelectorAll('[data-mm-site-tab]')];
      let next = tabs.indexOf(current) + (event.key === 'ArrowRight' ? 1 : -1);
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      event.preventDefault();
      activate(tabs[(next + tabs.length) % tabs.length].dataset.mmSiteTab, true);
      drawer.querySelector('.mm-cart-scroll')?.scrollTo({top: 0});
    });
    document.querySelectorAll('dialog').forEach(dialog => {
      if (!['mm-bag','mm-quick'].includes(dialog.id)) return;
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    });
    const menu = document.querySelector('.mm-menu');
    const menuTrigger = menu?.querySelector('summary');
    const closeMenu = (restore = false) => {
      if (!menu?.open) return;
      menu.open = false;
      if (restore) menuTrigger.focus();
    };
    menu?.addEventListener('toggle', () => {
      menuTrigger.setAttribute('aria-expanded', String(menu.open));
      if (menu.open) {
        document.documentElement.style.setProperty('--mm-menu-top', Math.max(0, document.querySelector('.header').getBoundingClientRect().bottom) + 'px');
        menu.querySelector('[data-mm-menu-close]')?.focus();
      }
    });
    document.addEventListener('click', event => {
      if (event.target.closest('[data-mm-menu-close]')) closeMenu(true);
      else if (menu?.open && !menu.contains(event.target)) closeMenu();
    });
    document.addEventListener('keydown', event => {
      if (!menu?.open) return;
      if (event.key === 'Escape') { event.preventDefault(); closeMenu(true); }
      if (event.key !== 'Tab') return;
      const items = [...menu.querySelectorAll('summary,a[href],button,select')].filter(el => el.getClientRects().length && !el.disabled);
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    matchMedia('(min-width:961px)').addEventListener('change', event => { if (event.matches) closeMenu(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true}); else boot();
})();
